import PropTypes from 'prop-types';
import React from 'react';
import { Modal as MUIModal } from '@material-ui/core';
import styled from 'styled-components';
import { Box } from '@/components/UIKit/Grid';
import Panel from '../Panel';

const StyledBox = styled(Box)`
  min-width: 400px;
`;

function Modal({ children, className, style, ...props }) {
  return (
    <MUIModal {...props} style={{ zIndex: 10000, display: 'flex' }}>
      <Box style={{ margin: 'auto' }}>
        <Panel>
          <StyledBox className={className} style={style}>
            {children}
          </StyledBox>
        </Panel>
      </Box>
    </MUIModal>
  );
}

Modal.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object,
};
Modal.defaultProps = {
  children: <div />,
  className: '',
  style: {},
};

export default Modal;
